import type { CampaignFormData } from '../types';

interface Step2Props {
  data: CampaignFormData;
  onChange: (field: keyof CampaignFormData, value: string) => void;
}

const Step2Details = ({ data, onChange }: Step2Props) => (
  <div className="space-y-6" dir="rtl">
    <div>
      <h2 className="text-xl font-black text-stone-800 mb-1">تفاصيل الحملة</h2>
      <p className="text-stone-500 text-sm">اشرح قصتك بالتفصيل لتقنع الداعمين</p>
    </div>

    {/* Full Story */}
    <div>
      <label className="block text-sm font-semibold text-stone-700 mb-2">
        قصة حملتك <span className="text-red-400">*</span>
      </label>
      <textarea
        value={data.story}
        onChange={(e) => onChange('story', e.target.value)}
        placeholder="اكتب قصتك بالتفصيل... من أنت؟ ما هو مشروعك؟ لماذا تحتاج الدعم؟ كيف ستستخدم الأموال؟"
        rows={8}
        maxLength={500}
        className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-700 focus:outline-none focus:border-emerald-400 resize-none text-right placeholder-stone-400 leading-relaxed"
      />
      <div className="flex justify-between mt-1">
        <span className="text-xs text-stone-400">كلما كانت القصة أوضح، زاد الدعم</span>
        <span className="text-xs text-stone-400">{data.story.length}/500</span>
      </div>
    </div>

    {/* Cover Image URL */}
    <div>
      <label className="block text-sm font-semibold text-stone-700 mb-2">
        صورة الغلاف
      </label>
      <div className="border-2 border-dashed border-stone-200 rounded-xl p-6 text-center hover:border-emerald-300 transition-colors">
        <div className="w-12 h-12 flex items-center justify-center bg-stone-100 rounded-xl mx-auto mb-3">
          <i className="ri-image-add-line text-2xl text-stone-400"></i>
        </div>
        <p className="text-sm font-medium text-stone-600 mb-1">أضف صورة جذابة لحملتك</p>
        <p className="text-xs text-stone-400 mb-3">الصور تزيد من فرص الحصول على الدعم بنسبة 3x</p>
        <input
          type="url"
          value={data.coverImageUrl}
          onChange={(e) => onChange('coverImageUrl', e.target.value)}
          placeholder="https://... رابط الصورة"
          className="w-full border border-stone-200 rounded-lg px-3 py-2 text-xs text-stone-700 focus:outline-none focus:border-emerald-400 text-right placeholder-stone-400"
        />
      </div>
      {data.coverImageUrl && (
        <div className="mt-3 rounded-xl overflow-hidden h-40">
          <img
            src={data.coverImageUrl}
            alt="معاينة الغلاف"
            className="w-full h-full object-cover object-top"
            onError={(e) => { (e.target as HTMLImageElement).style.display = 'none'; }}
          />
        </div>
      )}
    </div>

    {/* Tags */}
    <div>
      <label className="block text-sm font-semibold text-stone-700 mb-2">
        الوسوم (Tags)
      </label>
      <input
        type="text"
        value={data.tags}
        onChange={(e) => onChange('tags', e.target.value)}
        placeholder="مثال: تعليم، أطفال، تقنية (افصل بفاصلة)"
        className="w-full border border-stone-200 rounded-xl px-4 py-3 text-sm text-stone-800 focus:outline-none focus:border-emerald-400 text-right placeholder-stone-400"
      />
      <p className="text-xs text-stone-400 mt-1">تساعد الوسوم في اكتشاف حملتك</p>
    </div>

    {/* Social Links */}
    <div>
      <label className="block text-sm font-semibold text-stone-700 mb-3">
        روابط التواصل الاجتماعي (اختياري)
      </label>
      <div className="space-y-3">
        {[
          { field: 'twitter' as keyof CampaignFormData, icon: 'ri-twitter-x-line', placeholder: 'رابط تويتر / X' },
          { field: 'instagram' as keyof CampaignFormData, icon: 'ri-instagram-line', placeholder: 'رابط إنستغرام' },
          { field: 'youtube' as keyof CampaignFormData, icon: 'ri-youtube-line', placeholder: 'رابط يوتيوب' },
        ].map(({ field, icon, placeholder }) => (
          <div key={field} className="flex items-center gap-3">
            <div className="w-10 h-10 flex items-center justify-center bg-stone-100 rounded-xl shrink-0">
              <i className={`${icon} text-stone-500`}></i>
            </div>
            <input
              type="url"
              value={data[field] as string}
              onChange={(e) => onChange(field, e.target.value)}
              placeholder={placeholder}
              className="flex-1 border border-stone-200 rounded-xl px-4 py-2.5 text-sm text-stone-800 focus:outline-none focus:border-emerald-400 text-right placeholder-stone-400"
            />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default Step2Details;
